
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface LogicOperatorSelectProps {
  value: string;
  onValueChange: (value: string) => void;
}

export const LogicOperatorSelect = ({ value, onValueChange }: LogicOperatorSelectProps) => {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-20 h-6 text-xs">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="any_of">any of</SelectItem>
        <SelectItem value="all_of">all of</SelectItem>
      </SelectContent>
    </Select>
  );
};
